import React from "react";
import {
  Typography,
  Checkbox,
  FormControlLabel,
  Box,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DeleteIcon from "@mui/icons-material/Delete";
import DocumentOnFileSection from "./DocumentOnFileSection";
import LawFirmUserFormFields from "./LawFirmUserFormFields";

function UsersStep({
  users,
  handleRemoveUser,
  handleUserInputChange,
  lawFirmLocations,
  positionOptions,
  lawSchools,
  legalServiceProfessionals,
  setUsers,
}) {
  return (
    <>
      {users.map((user, index) => (
        <Box
          key={
            user.lawfirm_user_id ??
            `${user.email}-${user.firmEmail}-${user.firstName}-${user.lastName}-${user.location}`
          }
          sx={{
            mb: 4,
            p: 2,
            border: "1px solid #e0e0e0",
            borderRadius: 1,
          }}
        >
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="h6">User {index + 1}</Typography>
                {users.length > 1 && (
                  <IconButton
                    onClick={() => handleRemoveUser(index)}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Box>
            </Grid>

            <LawFirmUserFormFields
              index={index}
              user={user}
              handleUserInputChange={handleUserInputChange}
              locations={lawFirmLocations}
              positionOptions={positionOptions}
              lawSchools={lawSchools}
              legalServiceProfessionals={legalServiceProfessionals}
            />

            {user.position === "Attorney" && (
              <>
                <DocumentOnFileSection
                  title="GIA Document"
                  checkboxLabel="Is GIA on file?"
                  isOnFile={user.is_gia_on_file}
                  onToggleOnFile={(e) =>
                    handleUserInputChange(
                      index,
                      "is_gia_on_file",
                      e.target.checked
                    )
                  }
                  documentLink={user.gia_document_link}
                  documentName={user.gia_document_name}
                  selectedFile={user.gia_file}
                  displayFileName={user.gia_document_name}
                  uploadInputId={`gia-upload-${index}`}
                  onSelectFile={(file) => {
                    const updatedUsers = [...users];
                    updatedUsers[index].gia_file = file;
                    updatedUsers[index].gia_document_name = file.name;
                    setUsers(updatedUsers);
                  }}
                  changeButtonLabel="Change GIA Document"
                  uploadButtonLabel="Upload New GIA Document"
                  existingPrefix="Existing GIA Document:"
                  emptyMessage="No GIA document uploaded yet."
                  fallbackLinkLabel="Download GIA"
                />
                <DocumentOnFileSection
                  title="LOA Document"
                  checkboxLabel="Is LOA on file?"
                  isOnFile={user.is_loa_on_file}
                  onToggleOnFile={(e) =>
                    handleUserInputChange(
                      index,
                      "is_loa_on_file",
                      e.target.checked
                    )
                  }
                  documentLink={user.loa_document_link}
                  documentName={user.loa_document_name}
                  selectedFile={user.loa_file}
                  displayFileName={user.loa_document_name}
                  uploadInputId={`loa-upload-${index}`}
                  onSelectFile={(file) => {
                    const updatedUsers = [...users];
                    updatedUsers[index].loa_file = file;
                    updatedUsers[index].loa_document_name = file.name;
                    setUsers(updatedUsers);
                  }}
                  changeButtonLabel="Change LOA Document"
                  uploadButtonLabel="Upload New LOA Document"
                  existingPrefix="Existing LOA Document:"
                  emptyMessage="No LOA document uploaded yet."
                  fallbackLinkLabel="Download LOA"
                />
              </>
            )}

            <Grid size={{ xs: 12 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={user.sendInvite}
                    onChange={(e) =>
                      handleUserInputChange(
                        index,
                        "sendInvite",
                        e.target.checked
                      )
                    }
                  />
                }
                label="Send Invite Email"
              />
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
}

export default UsersStep;
